import styles from "../Employer.module.css";

type Props = {
  icon: string;
  title: string;
  description: string;
};

const FeaturesCard = ({ icon, title, description }: Props) => {
  return (
    <div className={styles.featuresCard}>
      <img src={icon} className={styles.featureIcon} />
      <h3 className={styles.featureTitle}>{title}</h3>
      <p className={styles.featureDesc}>{description}</p>
    </div>
  );
};

export default FeaturesCard;
